import moment from 'moment'
import { ChangeEvent, useEffect, useState } from 'react'
// defined from useReactTable
interface ITableCellEditableProps {
  getValue: Function,
  row: any,
  column: any,
  table: any
}

export const TableCellEditable = ({ getValue, row, column, table }: ITableCellEditableProps) => {

  const initialValue = getValue()
  const [value, setValue] = useState(initialValue)

  const columnMeta = column.columnDef.meta
  const tableMeta = table.options.meta

  useEffect(() => {
    setValue(value)
  }, [value])

  const handleChangeValue = (e: any) => {
    const value = e.target.value
    if (e.target.type === 'number') {
      let valueChange = '0'
      if (value.trim() === '') {
        valueChange = '0';
      }
      // Nếu giá trị là 0 hoặc nhiều số 0 ở đầu, thay thế bằng 0
      else {
        valueChange = value.toString()
        .replace(/^0+/, '0') // Nếu giá trị là 0 hoặc nhiều số 0 ở đầu
        .replace(/(0+)(,|\.)(\d+)/, '0$2$3')
        .replace(/^(0+)(\d+)/, '$2')
      }
     
      setValue(valueChange)
    }else{
      setValue(value)
    }
  }
  const handleBlur = () => {
    tableMeta?.blurData(row.index, column.id, value)
  }

  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value)
    tableMeta?.blurData(row.index, column.id, e.target.value)
  }

  // render
  // for edit
  if (tableMeta?.editedRows[row.id].isEdit) {
    let componentToRender;

    switch (columnMeta?.type) {
      case 'select':
        componentToRender = (
          <select onChange={handleSelectChange} value={initialValue}>
            {columnMeta?.options?.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )
        break
      case 'read':
        componentToRender = (
          <span>{value}</span>
        )
        break
      default:
        componentToRender = (
          <input
            type={columnMeta?.type || 'text'}
            value={value}
            onChange={e => handleChangeValue(e)}
            onBlur={handleBlur}
          />
        )
    }

    return (
      <div>
        {componentToRender}
      </div>
    )
  }

  // for view
  return <span>{columnMeta?.type === 'date' ? moment(value).locale('vi').format('L') : value}</span>
}